export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8679.2cf7451a.jpg";